import {
	SubscriptionStatus,
	SubscriptionType,
} from 'domain/subscription/interfaces/Subscription';

interface EditSubscriptionTooltipContentProps {
	subscriptionStatus: SubscriptionStatus;
	subscriptionType: SubscriptionType;
	isSalesAdmin: boolean;
}

export const EditSubscriptionTooltipContent: React.FC<
	EditSubscriptionTooltipContentProps
> = ({ subscriptionStatus, subscriptionType, isSalesAdmin }) => {
	if (subscriptionStatus === SubscriptionStatus.Canceled) {
		return <>Canceled subscriptions cannot be edited.</>;
	}

	if (
		subscriptionStatus === SubscriptionStatus.Ordered &&
		subscriptionType === SubscriptionType.Trial
	) {
		return <>Ordered subscriptions cannot be edited.</>;
	}

	if (isSalesAdmin && subscriptionType !== SubscriptionType.Trial) {
		return <>You only have permission to edit trial subscriptions.</>;
	}

	return null;
};
